<template>
  <div class="footer-global">
    <div class="container footer-global-content">
      <ul class="global-list" v-for="(list, i) in lists" :key="i">
        <li class="global-list-item" v-for="(item, j) in list.items" :key="j">
          <a :href="item.url">
            {{ item.name }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
    name: 'FooterGlobal',
    data () {
        return {
            lists: [
                {
                    items: [
                        { name: 'Academic affairs', url: 'https://www.uni-hamburg.de/en/campuscenter.html' },
                        { name: 'Research', url: 'https://www.uni-hamburg.de/en/forschung.html' },
                        { name: 'International affairs', url: 'https://www.uni-hamburg.de/en/internationales.html' },
                        { name: 'University', url: 'https://www.uni-hamburg.de/en/uhh.html' },
                        {
                            name: 'Faculties',
                            url: 'https://www.uni-hamburg.de/en/uhh/organisation/fakultaeten-fachbereiche.html',
                        },
                    ],
                },
                {
                    items: [
                        { name: 'Apps', url: 'https://www.uni-hamburg.de/en/newsroom/presse/publikationen/apps.html' },
                        { name: 'Campus Navigation', url: 'https://www.uni-hamburg.de/onTEAM/campus/index_e.html' },
                        { name: 'Jobs', url: 'https://www.uni-hamburg.de/en/uhh/stellenangebote.html' },
                        {
                            name: 'University Elections',
                            url: 'https://www.uni-hamburg.de/uhh/organisation/stabsstellen/recht/wahlen.html',
                        },
                        { name: 'Continuing studies', url: 'https://www.uni-hamburg.de/en/service/weiterbildung.html' },
                        { name: 'Site map', url: 'https://www.uni-hamburg.de/en/sitemap.html' },
                        { name: 'Index A to Z', url: 'https://www.uni-hamburg.de/en/abisz.html' },
                    ],
                },
                {
                    items: [
                        {
                            name: 'Prospective students',
                            url: 'https://www.uni-hamburg.de/en/campuscenter/studienorientierung.html',
                        },
                        { name: 'Students', url: 'https://www.uni-hamburg.de/en/campuscenter.html' },
                        {
                            name: 'International prospective students',
                            url: 'https://www.uni-hamburg.de/en/campuscenter/bewerbung/international.html',
                        },
                        {
                            name: 'Young research',
                            url: 'https://www.uni-hamburg.de/en/forschung/nachwuchs/promotion.html',
                        },
                        { name: 'Researches', url: 'https://www.uni-hamburg.de/en/forschung.html' },
                        { name: 'Staff', url: 'https://www.kus.uni-hamburg.de/en.html' },
                        {
                            name: 'Prospective continuing education students',
                            url: 'https://www.uni-hamburg.de/en/service/weiterbildung.html',
                        },
                        { name: 'Alumni', url: 'https://alumni-uhh.de/en/home/news.html' },
                        { name: 'Journalists', url: 'https://www.uni-hamburg.de/en/newsroom/presse.html' },
                        { name: 'Refugees', url: 'https://www.uni-hamburg.de/en/uhhhilft.html' },
                    ],
                },
            ],
        };
    },
};
</script>


<style scoped>
.footer-global {
  background: #027bcb;
  padding: 68px 20px 130px 20px;
  font-size: 17px;
}

.footer-global-content {
  display: flex;
  flex-direction: row;
}

@media (max-width: 810px) {
  .footer-global-content {
    flex-direction: column;
  }
}

.global-list {
  list-style: none;
  flex-grow: 1;
}

.global-list-item {
  height: 30px;
  white-space: nowrap;
}

.global-list-item a {
  font-family: 'TheSansUHH-Caps', sans-serif;
  font-weight: 600;
  font-size: 17px;
  line-height: 22px;
  color: white;
  text-decoration: none;
}

.global-list-item a:hover {
  text-decoration: underline;
}
</style>
